// Why?--better typing than _.noop
export const noop = () => {};
